export default __webpack_public_path__ + "static/media/KZ.T.19.2321.55cf4bd6.svg";